module.exports = __webpack_public_path__ + "src/images/eventomania-dark.png?ed423ebc76666ead41911c159d4adb91";


//////////////////
// WEBPACK FOOTER
// ./src/images/eventomania-dark.png
// module id = 297
// module chunks = 0